/*=========================================================================================
  File Name: moduleCategoryAssessmentGetters.js
  Description: CategoryAssessment Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
   
}
